import IMask from 'imask';

class Masked {
  constructor(imask) {
    this.imask = imask;
  }

  setValue(value) {
    this.imask.value = value;
    this.imask.updateValue();
  }
}

function apply(el) {
  let iMask;

  switch (el.dataset.mask) {
    case 'currency':
      iMask = currencyMask(el);
      break;
  }

  return new Masked(iMask);
}

function applyToAll() {
  document.querySelectorAll('[data-mask]').forEach(el => apply(el));
}

function getOptions(el, defaults) {
  return Object.assign(
    {},
    defaults,
    el.dataset.maskOptions ?
      JSON.parse(el.dataset.maskOptions) :
      {}
  );
}

function currencyMask(el) {
  const options = getOptions(el, {
    scale: 2,
    signed: false,
    min: 0,
    max: null,
  });

  const iMaskOptions = {
    mask: Number,
    scale: options.scale,
    signed: options.signed,
    thousandsSeparator: ',',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: '.',
    mapToRadix: ['.'],
  };

  if (options.min !== null) {
    iMaskOptions.min = parseFloat(options.min);
  }

  if (options.max !== null) {
    iMaskOptions.max = parseFloat(options.max);
  }

  return IMask(el, iMaskOptions);
}

export default {
  apply,
  applyToAll,
};
